import vue from 'vue';

vue.filter('numberMax', (value, max = 9, replacer = '+') => {
    if (value > max)
        return replacer;
    return value;
});



// WEBPACK FOOTER //
// ./src/filters/number-max.filter.js